export const DATE_FORMAT = 'MM-DD-YYYY';

export const FORM_ITEM_LAYOUT = {
  labelCol: {
    xxl: { span: 6 },
    xl: { span: 8 },
    lg: { span: 8 },
    md: { span: 9 },
    sm: { span: 24 },
    xs: { span: 24 },
  },
  wrapperCol: {
    xxl: { span: 16 },
    xl: { span: 14 },
    lg: { span: 14 },
    md: { span: 13 },
    sm: { span: 24 },
    xs: { span: 24 },
  },
};

export const JOB_OPTIONS = [
  {
    value: 'syncPccFacilities',
    label: 'Sync PointClickCare Facilities',
  },
  {
    value: 'syncPccPatients',
    label: 'Sync PointClickCare Patients',
  },
  {
    value: 'syncPccFacilityPickList',
    label: 'Sync PointClickCare Facility Pick List',
  },
  {
    value: 'pullEcgReports',
    label: 'Pull ECG Reports',
  },
  {
    value: 'pushProgressNotes',
    label: 'Push Progress Notes',
  },
];

export const LIST_LIMIT = 20;

export const REPORT_OPTIONS = [
  {
    value: 'encounters',
    label: 'Telemed Encounters',
  },
  {
    value: 'facilities',
    label: 'Facilities',
  },
  {
    value: 'accounts',
    label: 'Accounts',
  },
];

export const SELECT_REFETCH_DELAY = 800;

export const SELECT_LIMIT = 10;

export const SEX_OPTIONS = [
  {
    label: 'Male',
    value: 'M',
  },
  {
    label: 'Female',
    value: 'F',
  },
];

export const ALLERGY_TYPES = [
  'Allergy',
  'Intolerance',
  'Propensity to Adverse Reactions',
  'Unknown',
];

export const ALLERGY_CLINICAL_STATUSES = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Prior History',
    value: 'priorHistory',
  },
  {
    label: 'Resolved',
    value: 'resolved',
  },
];
